(() => {
  const root = document.querySelector('[data-style-quiz]');
  if (!root) return;

  const questions = [
    { eyebrow: 'The island question', title: 'You wake up on an island. Which one do you secretly hope it is?', options: [
      ['The one with old ruins.', 'There are fruit trees and a diary someone left behind.', { inward: 2, analog: 3, tender: 1 }],
      ['The one with white cliffs.', 'Just clean wind, clear water and a very long horizon.', { structured: 2, restrained: 3, inward: 1 }],
      ['The one that glows at night.', 'Moonlit wings move through a garden you have never seen.', { future: 3, edgy: 2, instinctive: 1 }],
      ['The one with giant flowers.', 'Every bird is curious and nothing is a normal size.', { outward: 2, expressive: 3, tender: 1 }],
    ] },
    { eyebrow: 'A secret door', title: 'You find a door where no door should be. What is behind it?', options: [
      ['A tiny kitchen.', 'Tea is warm and someone has saved you a seat.', { tender: 3, outward: 1, analog: 1 }],
      ['A very quiet room.', 'There is one perfect window and absolutely no clutter.', { structured: 3, restrained: 2, inward: 1 }],
      ['A room full of paintings.', 'Colors drift across the walls like a half-remembered dream.', { future: 2, expressive: 2, edgy: 1 }],
      ['A forgotten library.', 'The best book has notes written in all the margins.', { analog: 3, inward: 2, edgy: 1 }],
    ] },
    { eyebrow: 'A free afternoon', title: 'Four hours have appeared in your day. Pick the first move.', options: [
      ['Get pleasantly lost.', 'Choose a street and keep walking until something happens.', { instinctive: 3, future: 1, outward: 1 }],
      ['Make one small thing.', 'Hands busy, phone away, no need for it to be useful.', { tender: 2, analog: 2, inward: 1 }],
      ['Call my favorite person.', 'We can decide what to do after we meet.', { outward: 3, expressive: 1, tender: 1 }],
      ['Reset my whole space.', 'Headphones on. Everything goes back where it belongs.', { structured: 3, restrained: 2 }],
    ] },
    { eyebrow: 'Weather report', title: 'If your next week had weather, what would you choose?', options: [
      ['Soft rain, warm windows.', 'Nowhere urgent to be and something good to reread.', { tender: 2, analog: 3, inward: 1 }],
      ['A crisp blue morning.', 'The air is clear and the whole day feels possible.', { restrained: 2, structured: 2, future: 1 }],
      ['A warm thunderstorm.', 'A little dramatic, a little dangerous, never boring.', { edgy: 3, expressive: 1, instinctive: 1 }],
      ['A sudden sun shower.', 'Everyone runs outside and starts laughing at once.', { outward: 2, expressive: 3, tender: 1 }],
    ] },
    { eyebrow: 'The last page', title: 'Which ending makes a story stay with you?', options: [
      ['It returns to the beginning.', 'The same scene means something completely different now.', { analog: 3, structured: 1, inward: 1 }],
      ['It ends on the next step.', 'The future stays open and I get to imagine the rest.', { future: 3, instinctive: 2 }],
      ['Everyone finds each other.', 'I do not need a twist. I need them to be okay.', { tender: 3, outward: 2 }],
      ['The final image is strange.', 'I cannot explain it, but I will think about it for days.', { edgy: 3, expressive: 2, inward: 1 }],
    ] },
  ];

  const prototypes = {
    vintage: { inward: 3, tender: 3, analog: 3, instinctive: 1, restrained: 1 },
    clean: { structured: 4, restrained: 4, inward: 1 },
    painted: { restrained: 3, future: 3, instinctive: 3, tender: 1, structured: 1 },
    cute: { tender: 3, instinctive: 2, outward: 2, expressive: 2, analog: 2 },
    color: { expressive: 3, outward: 3, instinctive: 2, edgy: 2, future: 1 },
    dark: { inward: 3, edgy: 3, restrained: 2, analog: 2, structured: 1 },
  };
  const worlds = [...root.querySelectorAll('[data-quiz-world]')];
  let step = 0;
  let answers = [];
  const $ = (selector) => root.querySelector(selector);

  function showQuestion() {
    $('[data-quiz-questions]').hidden = false;
    $('[data-quiz-results]').hidden = true;
    const question = questions[step];
    $('[data-quiz-counter]').textContent = `Style personality · ${step + 1} of ${questions.length}`;
    $('[data-quiz-progress]').style.width = `${((step + 1) / questions.length) * 100}%`;
    $('[data-quiz-eyebrow]').textContent = `${question.eyebrow} · 0${step + 1}`;
    $('[data-quiz-title]').textContent = question.title;
    $('[data-quiz-back]').disabled = step === 0;
    const options = $('[data-quiz-options]');
    options.replaceChildren();
    question.options.forEach(([title, description], index) => {
      const button = document.createElement('button');
      button.type = 'button';
      const number = document.createElement('span');
      number.textContent = `0${index + 1}`;
      const heading = document.createElement('strong');
      heading.textContent = title;
      const detail = document.createElement('small');
      detail.textContent = description;
      const cta = document.createElement('b');
      cta.textContent = 'Choose this →';
      button.append(number, heading, detail, cta);
      button.addEventListener('click', () => choose(index));
      options.append(button);
    });
  }

  function rankWorlds() {
    const totals = {};
    answers.forEach((answer, index) => {
      const traits = questions[index].options[answer][2];
      Object.entries(traits).forEach(([trait, value]) => { totals[trait] = (totals[trait] || 0) + value; });
    });
    return worlds.map((world) => ({ world, score: Object.entries(prototypes[world.dataset.key] || {}).reduce((sum, [trait, weight]) => sum + (totals[trait] || 0) * weight, 0) }))
      .sort((a, b) => b.score - a.score).map(({ world }) => world);
  }

  function showResult() {
    const [first, second] = rankWorlds();
    if (!first) return;
    const destination = new URL('/pages/world-result', window.location.href);
    destination.searchParams.set('quiz_result', first.dataset.key);
    if (second) destination.searchParams.set('second_match', second.dataset.key);
    window.location.assign(destination.href);
  }

  function choose(index) {
    answers = [...answers.slice(0, step), index];
    if (step === questions.length - 1) showResult();
    else { step += 1; showQuestion(); }
  }
  $('[data-quiz-back]').addEventListener('click', () => {
    if (!step) return;
    step -= 1;
    answers = answers.slice(0, step);
    showQuestion();
  });
  $('[data-quiz-restart]').addEventListener('click', () => { answers = []; step = 0; showQuestion(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  showQuestion();
})();
